import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, lastValueFrom } from 'rxjs';

import { EventTypes, StyleVariants } from '@site-mate/dashpivot-shared-library';

import { AppHierarchy } from 'app/shared/model/app-hierarchy.enum';

import { EventsService } from '../../shared/service/events/events.service';
import { ToastrService } from '../../shared/service/toastr.service';
import { ListItemSelectionService } from '../list-item-selection.service';
import { ListItemsService } from '../list-items.service';

@Component({
  selector: 'cc-add-list-modal',
  templateUrl: './bulk-apply-list-row-style-modal.component.html',
  styleUrls: ['./bulk-apply-list-row-style-modal.component.scss'],
})
export class BulkApplyListRowStyleModal {
  @Input() parent: { hierarchy: Exclude<AppHierarchy, AppHierarchy.Team>; id: string };
  @Input() listId: string;

  listName = '';
  isSaving = false;

  style: StyleVariants;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly listItemsService: ListItemsService,
    private readonly toast: ToastrService,
    private readonly listItemSelectionService: ListItemSelectionService,
    private readonly eventsService: EventsService,
  ) {}

  cancelApplyListRowStyles() {
    this.activeModal.dismiss();
  }

  async applyListItemColours(event: Event) {
    const selectedItemIds = await firstValueFrom(this.listItemSelectionService.selectedItems$);
    event.preventDefault();
    if (this.isSaving || !this.style) {
      return;
    }

    try {
      this.isSaving = true;
      const { fullList } = await lastValueFrom(
        this.listItemsService.applyStyle({
          listId: this.listId,
          itemIds: [...selectedItemIds],
          parent: this.parent,
          style: this.style,
        }),
      );
      this.activeModal.close({
        fullList,
        selectedItemIds,
        style: this.style,
      });
      this.toast.successByKey('listRowColorsBulkApplied');
      this.eventsService.trackEvent(EventTypes.ListBulkItemColourApplied);
    } catch (err) {
      this.toast.errorByKey('failedToBulkApplyListRowColors');
    }
    this.isSaving = false;
  }
}
